import { combineReducers } from 'redux'

import { DATE_VALUES } from 'utils/dateUtils'

import { COMPANY_FILTER_CHANGE } from '../PartnerOptions/constants'

import {
  CREATED_BY_FILTER_CHANGE,
  DATE_FILTER_CHANGE,
  DEFAULT_PAGE_NUMBER,
  EVENTS_FILTER_CHANGE,
  FETCH_ACTIVITIES_ASYNC,
  FETCH_ALL_FILTERS_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SORT_PROPERTY_CHANGE,
  TARGETS_FILTER_CHANGE,
} from './constants'

const initialState = {
  data: {},
  loader: false,
  error: null,
  sortProperty: '', // first_name-desc
  selectedEventType: [],
  selectedTargets: [],
  createdBy: [],
  allFiltersLoader: false,
  page: DEFAULT_PAGE_NUMBER,
  search: '',
  dateFilter: DATE_VALUES.MONTH,
}

const mapAndSortFilters = (filters) =>
  filters
    .map((filter) => ({ label: filter, value: filter }))
    .sort((a, b) => a.label.localeCompare(b.label))

function activitiesReducer() {
  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case FETCH_ACTIVITIES_ASYNC.INITIATE:
        return {
          ...state,
          page: DEFAULT_PAGE_NUMBER,
          loader: true,
          sortProperty: '',
        }
      case FETCH_ACTIVITIES_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case FETCH_ACTIVITIES_ASYNC.ERROR:
        return {
          ...state,
          page: DEFAULT_PAGE_NUMBER,
          error: action.error,
        }
      case FETCH_ACTIVITIES_ASYNC.CANCEL:
        return { ...state, loader: false }
      case EVENTS_FILTER_CHANGE:
        return {
          ...state,
          selectedEventType: action.payload.eventsTypeArray,
          loader: true,
          error: null,
          page: DEFAULT_PAGE_NUMBER,
        }
      case TARGETS_FILTER_CHANGE:
        return {
          ...state,
          selectedTargets: action.payload.targetsArray,
          loader: true,
          error: null,
          page: DEFAULT_PAGE_NUMBER,
        }
      case CREATED_BY_FILTER_CHANGE:
        return {
          ...state,
          createdBy: action.payload.createdByArray,
          loader: true,
          error: null,
          page: DEFAULT_PAGE_NUMBER,
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          loader: true,
        }
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          dateFilter: action.payload.dateFilter,
          loader: true,
          page: DEFAULT_PAGE_NUMBER,
        }
      case FETCH_ALL_FILTERS_ASYNC.INITIATE:
        return { ...state, allFiltersLoader: true }
      case FETCH_ALL_FILTERS_ASYNC.SUCCESS:
        return {
          ...state,
          allFiltersLoader: false,
          page: DEFAULT_PAGE_NUMBER,
          eventType: mapAndSortFilters(action.payload.data.eventTypes),
          target: mapAndSortFilters(action.payload.data.targetTypes),
          usernameGroups: mapAndSortFilters(action.payload.data.usernameGroups),
        }
      case FETCH_ALL_FILTERS_ASYNC.ERROR:
      case FETCH_ALL_FILTERS_ASYNC.CANCEL:
      case SEARCH_RESET:
        return { ...state, search: '' }
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          loader: true,
          page: DEFAULT_PAGE_NUMBER,
        }
      case SORT_PROPERTY_CHANGE:
        return {
          ...state,
          sortProperty: action.payload.value,
          loader: true,
        }
      default:
        return state
    }
  }
}

export default function () {
  const initialState = combineReducers({
    self: activitiesReducer(),
  })

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
